/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Unlocked_SkusInputs */

const en_field_unlocked_skus = /** @type {(inputs: Field_Unlocked_SkusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlocked SKUs`)
};

/**
* | output |
* | --- |
* | "Unlocked SKUs" |
*
* @param {Field_Unlocked_SkusInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_unlocked_skus = /** @type {((inputs?: Field_Unlocked_SkusInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Unlocked_SkusInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_unlocked_skus(inputs)
});